import React, {Component} from 'react';
import '../../../local_node_modules/react-select/dist/react-select.css';
import NoIdentifierModal from "./NoIdentifierModal";
import Select from "../../../local_node_modules/react-select";
import {Label, UncontrolledTooltip} from "reactstrap";
import {deepCopyObject, getExternalCustomers} from "../../../helper/helper";
import {validateField} from "../../../common/validation";
import {isValidNoIdentifier} from "../../../common/componentValidation";
import Alert from "react-s-alert";
import {request} from "../../../helper/APIUtils";
import {value} from "lodash/seq";
import {efatura, isEarsiv, isEfatura} from "../PredefinedInvoiceTypes";
import SweetAlert from "react-bootstrap-sweetalert";
import {showRetailCustomerVknTcknManuelInput} from "../../../helper/permission";
import {EntegratorConf} from "../../../constants";


class NoIdentifier extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modal : false,
			docType : this.props.docType,
			error : {},
			locationSelect : true,
			docExternalCustomer: null,
			personalFlag : null,
			isWritedVknTckn: showRetailCustomerVknTcknManuelInput(EntegratorConf.identifier),
			isVknTcknManuelInput: showRetailCustomerVknTcknManuelInput(EntegratorConf.identifier)
		};
		this.setDocExternalCustomer = this.setDocExternalCustomer.bind(this);
		this.validateField = this.validateField.bind(this);
		this.onChange = this.onChange.bind(this);
		this.redirect = this.redirect.bind(this);
		this.searchGIBUser = this.searchGIBUser.bind(this);
		this.renderGIBUserAlert = this.renderGIBUserAlert.bind(this);
		this.handleGIBUserAlertConfirm = this.handleGIBUserAlertConfirm.bind(this);
	}

	componentWillMount() {
		this.setState({docExternalCustomer: (this.props.docExternalCustomer || {})});
		if(this.props.docExternalCustomer){
			if( this.props.docExternalCustomer.vknTckn && this.props.docExternalCustomer.vknTckn.length > 10)
				this.setState({personalFlag:true});
			else
				this.setState({personalFlag:false});
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.error !== nextProps.error) {
			this.setState({error: nextProps.error});
		}
	}

	componentDidMount() {
		let docExternalCustomer = deepCopyObject(this.state.docExternalCustomer);
		if(!docExternalCustomer.recordId)
			this.getAddressOfCurrentBranch();
		this.setState({locationSelect: !(docExternalCustomer.manualInput && docExternalCustomer.manualInput === 1)})
	}

	setDocExternalCustomer(docExternalCustomer){
		this.setState({docExternalCustomer:docExternalCustomer,modal:false});
		this.props.listener(docExternalCustomer);
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	checkValue(key){
		return ((this.state.docExternalCustomer && this.state.docExternalCustomer[key]) ? this.state.docExternalCustomer[key] :  "");
	}

	onChange(e) {
		let self = this;
		const isWritedVknTckn = self.state.isWritedVknTckn;
		if(e.target.name=== "formattedName"){
			e.target.value = e.target.value.replace(/ +(?= )/g,'');
		}
		if (e.target && e.target.id && e.target.value && e.target.id === "postalZone" && isNaN(e.target.value))
			return;
		else {
			let docExternalCustomer = deepCopyObject((self.state.docExternalCustomer ? self.state.docExternalCustomer : {}));
			if(e.target.name === "vknTckn"){
				if(isWritedVknTckn){
					//self.searchGIBUser(e.target.value);
					if(e.target.value.length > 10)
						self.setState({personalFlag: true});
					else
						self.setState({personalFlag: false});
				}else {
					if (e.target.value === "11111111111")
						self.setState({personalFlag: true});
					else
						self.setState({personalFlag: false});
				}
			}
			if(e.target.name === "vknTckn"){
				let value = e.target.value.replace(/ /g, '');
				if(!isNaN(value,""))
					docExternalCustomer[e.target.name] = value;
			}else
				docExternalCustomer[e.target.name] = e.target.value;
			self.setState({docExternalCustomer});
			self.props.listener(docExternalCustomer);
		}
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
		if(id === "vknTckn")
			this.searchGIBUser(e.target.value);
	}

	locationSelect() {
		let locationSelect = !deepCopyObject(this.state.locationSelect);
		let manualInputObj = {
			target:{
				name: 'manualInput',
				value: locationSelect ? 0 : 1
			}
		};
		this.setState({
			locationSelect,
		}, () => this.onChange(manualInputObj));
	}

	getSubdivisionsForCity(cityFieldName) {
		let city = this.state.docExternalCustomer[cityFieldName];
		if (city === null) {
			return [];
		}

		let theCity = this.props.cities.find(obj => obj.cityName === city);

		if (theCity === undefined) {
			return [];
		}

		return theCity.subdivisions.map(subdiv => ({
			value: subdiv.name,
			label: subdiv.name
		}))
	}

	personalFlagConvert(){
		let self = this;
		const personalFlag = self.state.personalFlag;
		if(personalFlag === null){
			return null;
		}
		return !personalFlag;
	}

	save(e) {
		e.preventDefault();
		let docExternalCustomer = deepCopyObject(this.state.docExternalCustomer);
		let result = isValidNoIdentifier(docExternalCustomer,this.props.requiredTaxOffice);
		let error = result.error;
		let valid = result.valid;
		if (valid) {
			this.props.listener(docExternalCustomer);
		} else {
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 3000
			});
			this.setState({error});
		}
	}

	getAddressOfCurrentBranch(){
		let self = this;

		const params ={
			url:"/customer/getAddressOfCurrentBranch",
			method:"get"
		}
		request(params).then((response)=>{
			let docExternalCustomer = self.state.docExternalCustomer;
			const data = response.data;
			docExternalCustomer.cityName = data.city;
			docExternalCustomer.citySubdivisionName = data.citySubdivisionName;
			self.setState({docExternalCustomer});
		})
	}

	searchGIBUser(identifier){
		let self = this;
		const params={
			url:"/gibuser/getGIBUsersByIdentifier",
			method:"post",
			data:identifier
		}
		request(params).then(response=>{
			const gibUser = response.data;
			if(gibUser)
				self.renderGIBUserAlert(gibUser);
			else
				self.setState({alert:null});
		})
	}

	renderGIBUserAlert(gibUser) {
		let self = this;
		let externalCustomerAddress = null;
		if (gibUser.externalCustomerAddressList.length > 0) {
			externalCustomerAddress = gibUser.externalCustomerAddressList[0];
		}else {
			externalCustomerAddress = {
				buildingName: "",
				buildingNo: "",
				cityName: "",
				citySubdivisionName: "",
				countryName: "Türkiye",
				email: "",
				fax: "",
				postalAddressRegion: "",
				postalAddressRoom: "",
				postalZone: "",
				postboxAlias: "",
				recordId: null,
				streetName: "",
				telephone: "",
				webSite: "",
			};
		}
		const alert = (<SweetAlert showCancel warning
								   confirmBtnText="Tamam"
								   cancelBtnText="İptal"
								   confirmBtnBsStyle="success"
								   cancelBtnBsStyle="default"
								   title="Onay"
								   onCancel={() => this.setState({alert: null})}
								   onConfirm={() => this.handleGIBUserAlertConfirm(gibUser,externalCustomerAddress)}
		>
			{gibUser.vknTckn} vkn/tckn numaralı {gibUser.formattedName} ünvanlı kullanıcı GİB E-Fatura listesinde
			kayıtlı.
			E-Fatura olarak gönderilecek.
		</SweetAlert>);
		self.setState({alert})
	}

	handleGIBUserAlertConfirm(gibUser,externalCustomerAddress){
		let self = this;
		let type = efatura;
		type.externalCustomer = gibUser;
		type.externalCustomerAddress = externalCustomerAddress;
		type.invoiceTypeInfo ={
			invoiceTypeCode: "SATIS",
			profileId: "TEMELFATURA",
			accountingCost: null
		};
		self.redirect(type);
		self.setState({alert:null});
	}

	redirect = (type) => {
		let self = this;
		self.props.history.push({pathname: `/createEditInvoice/Tmp/0/EFATURA`, state: {type: type}});
	};

	render() {
		return (
			<div className="row">
				{this.state.alert}
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row">
					{this.state.isWritedVknTckn &&
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12" style={{marginRight: '0', padding: '0 0 0 15px'}}>
						<Label check className="col-sm-1 form-check-label">
							<input type="checkbox"
								   checked={!!this.state.isVknTcknManuelInput}
								   onChange={() => this.setState({isVknTcknManuelInput: !this.state.isVknTcknManuelInput})}
									id="VknTcknManuelInputCheckbox"/>
						</Label>
						<label className="col-sm-10">Vkn / Tckn bilgisi el ile girilsin</label>
					</div>
					}
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12" style={{marginRight: '0', padding: '0 0 0 15px'}}>
						<Label check className="col-sm-1 form-check-label">
							<input type="checkbox"
								   checked={!!(this.state.docExternalCustomer.manualInput && this.state.docExternalCustomer.manualInput === 1)}
								   onChange={() => this.locationSelect()}/>
						</Label>
						<label className="col-sm-10">Şehir / İlçe bilgileri el ile girilsin</label>
					</div>
				</div>
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>{(this.props.docType && this.props.docType==='SMM') ? 'VKN' : 'VKN/TCKN'}</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("vknTckn")}>
							{this.state.isWritedVknTckn && this.state.isVknTcknManuelInput ?
								<input className="form-control"
									   id="vknTckn"
									   type="text"
									   name="vknTckn"
									   data-vlength="10,11"
									   data-vdata="identifier"
									   onBlur={this.validateField}
									   value={this.checkValue("vknTckn")}
									   onChange={(e) => e && this.onChange({target: {name: "vknTckn", value: e.target.value}})}/>
								:
								<Select
									id="vknTckn"
									clearable={false}
									placeholder="Seçiniz..."
									noResultsText="Kayıt bulunamadı."
									value={this.checkValue("vknTckn")}
									options={[
										{label: "11111111111 ( Şahıs ) ", value: "11111111111"},
										{label: "2222222222  ( Firma ) ", value: "2222222222"}
									]}
									onChange={(e) => e && this.onChange({target:{
											name: "vknTckn",
											value: e.value
										}})}
								/>
							}
							{this.validateMessage("vknTckn") !== "" &&
							<UncontrolledTooltip placement="right" target={"vknTckn"} delay={0}>
								{this.validateMessage("vknTckn")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Ülke</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("countryName")}>
							<Select
								id="countryName"
								value={this.checkValue("countryName") || this.onChange({target: {name: "countryName", value: "Türkiye"}})}
								clearable={false}
								noResultsText="Sonuç yok"
								clearValueText="Temizle"
								placeholder="Seçiniz..."
								onChange={(e) => e && this.onChange({target: {name: "countryName", value: e.value}})}
								options={this.props.countries.map(country => ({value: country.longNameTr, label: country.longNameTr}))}
							/>
							{this.validateMessage("countryName") !== "" &&
							<UncontrolledTooltip placement="right" target={"countryName"} delay={0}>
								{this.validateMessage("countryName")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>İl</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("cityName")}>
							{this.state.locationSelect &&
							<Select
								id="cityName"
								value={this.checkValue("cityName")}
								clearable={false}
								data-vdata="required"
								noResultsText="Sonuç yok"
								clearValueText="Temizle"
								placeholder="Seçiniz..."
								onChange={(e) => e && this.onChange({target: {name: "cityName", value: e.value}})}
								options={this.props.cities.map(city => ({
									value: city.cityName,
									label: city.cityName
								}))}
							/>}
							{this.validateMessage("cityName") !== "" &&
							<UncontrolledTooltip placement="right" target={"cityName"} delay={0}>
								{this.validateMessage("cityName")}
							</UncontrolledTooltip>}

							{!this.state.locationSelect &&
							<input className="form-control"
								   type="text"
								   name="cityName"
								   data-vlength="1,255"
								   id="cityName"
								   ref="cityName"
								   onBlur={this.validateField}
								   value={this.checkValue("cityName")}
								   onChange={(e) => e && this.onChange({target: {name: "cityName", value: e.target.value}})}/>}
							{this.validateMessage('cityName') !== "" &&
							<UncontrolledTooltip placement="right" target="cityName" delay={0}>
								{this.validateMessage("cityName")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>İlçe</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("citySubdivisionName")}>
							{this.state.locationSelect &&
							<Select
								id="citySubdivisionName"
								value={this.checkValue("citySubdivisionName")}
								clearable={false}
								noResultsText="Sonuç yok"
								data-vdata="required"
								clearValueText="Temizle"
								placeholder="Seçiniz..."
								onChange={(e) => e && this.onChange({target: {name: "citySubdivisionName", value: e.value}})}
								options={this.getSubdivisionsForCity("cityName")}
							/>}
							{this.validateMessage("citySubdivisionName") !== "" &&
							<UncontrolledTooltip placement="right" target={"citySubdivisionName"} delay={0}>
								{this.validateMessage("citySubdivisionName")}
							</UncontrolledTooltip>}

							{!this.state.locationSelect &&
							<input className="form-control"
								   type="text"
								   name="citySubdivisionName"
								   data-vlength="1,255"
								   id="citySubdivisionName"
								   ref="citySubdivisionName"
								   onBlur={this.validateField}
								   value={this.checkValue("citySubdivisionName")}
								   onChange={(e) => e && this.onChange({target: {name: "citySubdivisionName", value: e.target.value}})}/>
							}
							{this.validateMessage('citySubdivisionName') !== "" &&
							<UncontrolledTooltip placement="right" target="citySubdivisionName" delay={0}>
								{this.validateMessage("citySubdivisionName")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>


				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Unvan</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className={"form-group" + this.validateClass("formattedName")}>
							<input className="form-control"
								   type="text"
								   data-vlength="0,350"
								   id="formattedName"
								   name="formattedName"
								   onBlur={(e) => this.validateField(e)}
								   onChange={this.onChange}
								   value={this.checkValue("formattedName")}/>
							{this.validateMessage("formattedName") !== "" &&
								<UncontrolledTooltip placement="right" target={"formattedName"} delay={0}>
									{this.validateMessage("formattedName")}
								</UncontrolledTooltip>}
						</div>
					</div>
				</div>

				{(this.state.personalFlag && this.state.personalFlag) &&
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
						 style={{marginRight: '0', padding: '0 0 0 15px'}}>
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Adı</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("givenName")}>
								<input className="form-control"
									   type="text"
									   data-vlength={(this.checkValue("vknTckn")).length !== 10 ? "1,255" : "0,255"}
									   id="givenName"
									   name="givenName"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("givenName")}/>
								{this.validateMessage("givenName") !== "" &&
								<UncontrolledTooltip placement="right" target={"givenName"} delay={0}>
									{this.validateMessage("givenName")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
				}

				{(this.state.personalFlag && this.state.personalFlag) &&
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
						 style={{marginRight: '0', padding: '0 0 0 15px'}}>
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Soyadı</label></div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("familyName")}>
								<input className="form-control"
									   type="text"
									   data-vlength={(this.checkValue("vknTckn")).length === 11 ? "1,255" : "0,255"}
									   id="familyName"
									   name="familyName"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("familyName")}/>
								{this.validateMessage("familyName") !== "" &&
								<UncontrolledTooltip placement="right" target={"familyName"} delay={0}>
									{this.validateMessage("familyName")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
				}


				{this.props.isEBelge &&
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row"
						 style={{marginRight: '0', padding: '0 0 0 15px'}}>
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>{"Vergi Dairesi" +
								(this.state.docExternalCustomer && this.state.docExternalCustomer.vknTckn &&
								this.state.docExternalCustomer.vknTckn.length === 10 && "2222222222" !== this.state.docExternalCustomer.vknTckn ? "*" : "")}</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("taxOffice")}>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="taxOffice"
									   name="taxOffice"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("taxOffice")}/>
								{this.validateMessage("taxOffice") !== "" &&
								<UncontrolledTooltip placement="right" target={"taxOffice"} delay={0}>
									{this.validateMessage("taxOffice")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
				}

				{this.props.docType === "EARSIVFATURA" && this.props.taxInclusiveAmount >= 9900 &&
					<div style={{marginRight: '0', marginTop:'20px', padding: '0 0 0 15px'}}>
						<div>
							<label style={{wordWrap: 'break-word', whiteSpace: 'normal',color: 'red'}}>
								<i className="fas fa-exclamation-circle" style={{color: 'red', marginRight: '8px'}}></i>
								2025 yılı itibarıyla, 9.900 TL ve üzeri faturalar için alıcının adı, soyadı
								ve TC kimlik numarası (veya firma adı ve VKN) zorunludur. Bu bilgileri sağlamadan bu tür faturalar kesilemez.
							</label>
						</div>
					</div>
				}

				<div className="col-sm-12">
					<div className="form-group">
						{/*<button type="button"
								className="TekBtn pull-right edit"
								style={{
									marginBottom: '5px',
									marginTop: '10px',
									marginRight: '28px',
									padding: '9px 54px 9px 23px',
									background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
								}}
								onClick={(e)=>this.save(e)}
								>Kaydet
						</button>*/}
						<button type="button"
								className="TekBtn pull-right edit"
								style={{
									marginBottom: '5px',
									marginTop: '10px',
									marginRight: '28px',
									padding: '9px 54px 9px 23px',
									background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
								}}
								onClick={(e)=> this.setState({modal:true})}>Diğer Bilgiler
						</button>
					</div>
				</div>

				{this.state.modal &&
				<NoIdentifierModal listener={this.setDocExternalCustomer}
								   title={(this.props.docType && this.props.docType==='SMM') ? "Yabancı Müşteri Bilgileri" :"Perakende Müşteri Bilgileri"}
								   modal={this.state.modal}
								   docExternalCustomer={this.state.docExternalCustomer}
								   cities={this.props.cities}
								   countries={this.props.countries}
								   docType={this.props.docType}
								   personalFlag={this.personalFlagConvert()}
				/>
				}
			</div>
		);
	}
}

export default NoIdentifier;